import React, { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaHandsHelping,
  FaPaperPlane,
  FaCheckCircle,
} from "react-icons/fa";

const VolunteerApplication = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    areaOfInterest: "",
    motivation: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Volunteer application:", formData);
    alert("Thank you for applying! We will get back to you within 3-5 working days.");
  };

  const areaOptions = [
    "Field Work (Awareness Camps/Plantation)",
    "Teaching/Skill Training (Job Readiness/PoSH)",
    "Digital Support (Social Media/Content Writing)",
    "Event Management",
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] py-14 px-4 sm:px-6 lg:px-8">
      <div className="absolute top-10 left-0 w-72 h-72 bg-[#1298b5]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-0 w-80 h-80 bg-[#f97316]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          <div className="bg-white/90 backdrop-blur-sm p-7 md:p-9 rounded-3xl border border-[#d8f4f8] shadow-xl h-full flex flex-col">
            <span className="inline-block w-fit bg-[#eafaff] text-[#1298b5] border border-[#bdeef5] px-4 py-1.5 rounded-full text-sm font-semibold mb-5">
              Join as Volunteer
            </span>

            <h1 className="text-3xl md:text-5xl font-extrabold text-[#073b4c] mb-4 leading-tight">
              Become a Pillar of{" "}
              <span className="text-[#1298b5]">Aabharan</span>
            </h1>

            <p className="text-base md:text-lg text-gray-600 mb-6 leading-relaxed">
              Use your skills to adorn lives. Join our mission to empower women
              and protect the planet.
            </p>

            <div className="space-y-4 text-gray-700 mb-6">
              {[
                "Work with grassroots communities",
                "Flexible volunteer opportunities",
                "Be part of a compassionate network",
              ].map((item, index) => (
                <p key={index} className="flex items-start gap-3">
                  <FaCheckCircle className="text-[#1298b5] mt-1 flex-shrink-0" />
                  <span>{item}</span>
                </p>
              ))}
            </div>

            <div className="mt-auto">
              <img
                src="image1.png"
                alt="Volunteers working together in community"
                className="w-full h-52 lg:h-64 rounded-2xl shadow-md object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://via.placeholder.com/500x300?text=Volunteer+Image";
                  e.target.alt = "Volunteer image placeholder";
                }}
              />

              <div className="mt-5 h-1 w-20 bg-gradient-to-r from-[#1298b5] to-[#f97316] rounded-full"></div>
            </div>
          </div>

          <div className="bg-white/95 p-7 md:p-9 rounded-3xl shadow-2xl border border-[#d8f4f8] h-full flex flex-col">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 bg-gradient-to-br from-[#1298b5] to-[#0b819b] text-white rounded-2xl flex items-center justify-center text-xl shadow-md">
                <FaHandsHelping />
              </div>

              <div>
                <h2 className="text-2xl md:text-3xl font-extrabold text-[#073b4c]">
                  Apply to Volunteer
                </h2>
                <p className="text-gray-500 text-sm">
                  We'll get back within 3-5 working days.
                </p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5 flex-grow flex flex-col">
              <div className="space-y-5 flex-grow">
                <div>
                  <label
                    htmlFor="fullName"
                    className="block text-sm font-semibold text-[#073b4c] mb-1"
                  >
                    Full Name <span className="text-[#f97316]">*</span>
                  </label>

                  <div className="relative">
                    <FaUser className="absolute left-3 top-1/2 -translate-y-1/2 text-[#1298b5]" />
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition"
                      placeholder="e.g., Priya Sharma"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-semibold text-[#073b4c] mb-1"
                  >
                    Email Address <span className="text-[#f97316]">*</span>
                  </label>

                  <div className="relative">
                    <FaEnvelope className="absolute left-3 top-1/2 -translate-y-1/2 text-[#1298b5]" />
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition"
                      placeholder="you@example.com"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-semibold text-[#073b4c] mb-1"
                  >
                    Phone Number <span className="text-[#f97316]">*</span>
                  </label>

                  <div className="relative">
                    <FaPhone className="absolute left-3 top-1/2 -translate-y-1/2 text-[#1298b5]" />
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition"
                      placeholder="e.g., +91 98765 43210"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="areaOfInterest"
                    className="block text-sm font-semibold text-[#073b4c] mb-1"
                  >
                    Area of Interest <span className="text-[#f97316]">*</span>
                  </label>

                  <select
                    id="areaOfInterest"
                    name="areaOfInterest"
                    value={formData.areaOfInterest}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition bg-white"
                  >
                    <option value="" disabled>
                      Select an area
                    </option>

                    {areaOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="motivation"
                    className="block text-sm font-semibold text-[#073b4c] mb-1"
                  >
                    Why do you want to volunteer?{" "}
                    <span className="text-[#f97316]">*</span>
                  </label>

                  <textarea
                    id="motivation"
                    name="motivation"
                    rows={4}
                    value={formData.motivation}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition resize-none"
                    placeholder="Tell us about your motivation and any relevant skills"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-[#1298b5] to-[#0b819b] hover:from-[#f97316] hover:to-[#fb923c] text-white font-bold py-3 px-6 rounded-xl shadow-lg transition-all duration-300 hover:-translate-y-0.5 flex items-center justify-center gap-2"
                >
                  <FaPaperPlane />
                  Submit Application
                </button>

                <p className="text-xs text-gray-500 text-center mt-4">
                  By clicking submit, you agree to our{" "}
                  <a
                    href="/privacy"
                    className="text-[#1298b5] hover:text-[#f97316] hover:underline font-semibold"
                  >
                    privacy policy
                  </a>{" "}
                  and{" "}
                  <a
                    href="/terms"
                    className="text-[#1298b5] hover:text-[#f97316] hover:underline font-semibold"
                  >
                    terms of service
                  </a>
                  .
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VolunteerApplication;